module.exports = __webpack_public_path__ + "static/media/Download.2077298a.svg";